//
// Typography
// ==========
//
// Font families, sizing, and line spacing
//

export const baseFontSize = '0.75rem';
export const baseLineHeight = 1.25;
export const baseLetterSpacing = 0;

export const validTypefaceSizes = 'xxl xl large medium small xs';

//
// Font families
// =============
//
// When you're here, you're a font family
//

export const latoFontFamily = 'Lato';
export const latoFontFamilyStack = `${latoFontFamily}, sans-serif`;
export const latoNormalWeight = 500;
export const latoBoldWeight = 700;
export const latoLineHeight = 1.25;
export const latoLetterSpacing = '0.3px';

//
// Normal text
// ===========
//
// Basics
//

export const bodyFontFamily = latoFontFamilyStack;
export const bodyFontWeight = latoNormalWeight;
export const bodyBoldFontWeight = latoBoldWeight;
export const bodyFontSize = baseFontSize;
export const bodyLineHeight = latoLineHeight;
export const bodyLetterSpacing = latoLetterSpacing;

export const buttonFontFamily = latoFontFamilyStack;
export const buttonFontWeight = latoBoldWeight;
export const buttonLightFontWeight = latoNormalWeight;
export const buttonLetterSpacing = latoLetterSpacing;
export const buttonLargeFontSize = '0.875rem';
export const buttonLargeLineHeight = latoLineHeight;
export const buttonMediumFontSize = '0.75rem';
export const buttonMediumLineHeight = latoLineHeight;
export const buttonSmallFontSize = '0.625rem';
export const buttonSmallLineHeight = latoLineHeight;
export const buttonFontSize = buttonMediumFontSize;
export const buttonLineHeight = buttonMediumLineHeight;

export const labelFontFamily = latoFontFamilyStack;
export const labelFontWeight = latoBoldWeight;
export const labelLightFontWeight = latoNormalWeight;
export const labelFontSize = '0.75rem';
export const labelLineHeight = latoLineHeight;
export const labelLetterSpacing = latoLetterSpacing;

//
// Headlines
// =========
//
// Headers and shoulders above the rest
//

export const headlineFontFamily = latoFontFamilyStack;
export const headlineFontWeight = latoBoldWeight;
export const headlineLineHeight = latoLineHeight;
export const headlineLetterSpacing = latoLetterSpacing;

export const headlineXxlFontSize = '3rem';
export const headlineXlFontSize = '2rem';
export const headlineLargeFontSize = '1.5rem';
export const headlineMediumFontSize = '1.25rem';
export const headlineSmallFontSize = '1rem';
export const headlineXsFontSize = '0.75rem';

export const headLinePaddingBottom = '2rem';

//
// Subheadlines
// ============
//
// Headers and shoulders above the rest
//

export const subheadlineFontFamily = latoFontFamilyStack;
export const subheadlineFontWeight = latoNormalWeight;
export const subheadlineLineHeight = latoLineHeight;
export const subheadlineLetterSpacing = latoLetterSpacing;

export const subheadlineXxlFontSize = '1.25rem';
export const subheadlineXlFontSize = '1rem';
export const subheadlineLargeFontSize = '0.875rem';
export const subheadlineMediumFontSize = '0.75rem';
export const subheadlineSmallFontSize = '0.625rem';
export const subheadlineXsFontSize = '0.5rem';
